import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'

export function DownloadOutlined(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
          d="M16.2929 9.29289L13 12.5858V2H11V12.5858L7.70711 9.29289L6.29289 10.7071L12 16.4142L17.7071 10.7071L16.2929 9.29289Z"
          fill="currentColor"
        />
        <path
          d="M22 20V16H20V20H4V16H2V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  )
}
